import { Navigate, Outlet } from 'react-router-dom';
import { useAuth } from '../hooks/useAuth';
import { Spinner } from '../components/ui/spinner';

const AdminRoutes = () => {
  const { isAuthenticated, isLoading, checkAuthStatus } = useAuth();

  if (isLoading) {
    return (
      <div className="flex h-screen w-full items-center justify-center">
        <Spinner showSpinner />
      </div>
    );
  }

  // Check authentication status using the new method
  if (!isAuthenticated || !checkAuthStatus()) {
    return <Navigate to="/login" replace />;
  }

  // For now, allow all authenticated users to access admin routes
  // TODO: Implement role-based access control when user roles are available from API
  
  // Simply render nested routes without any layout - the layout is handled by parent MainLayout
  return <Outlet />;
};

export default AdminRoutes;